import { FC } from "react";
import { Trash2 } from "lucide-react";
import { Button } from "src/components/ui/button";

interface Props {
	observedUser?: string;
	formName: string;
	resetForm: () => void;
	redirectAndResetForm: () => void;
	onObserveAnotherUser?: () => void;
}

const QuitForm: FC<Props> = ({
	observedUser,
	resetForm,
	redirectAndResetForm,
	formName
}) => {
	return (
		<div className="flex flex-1 justify-center">
			<div className="flex flex-col items-center gap-2">
				<div className="flex flex-col items-center gap-2 my-8">
					<Trash2 size={64} data-testid="delete-forever-icon" />

					<p className="text-sm mt-8">{formName}</p>

					<p className="font-bold">
						Observation for {observedUser} has been quit
					</p>
				</div>

				<Button
					type="button"
					onClick={resetForm}
					className="w-full"
					variant="outline"
				>
					Start a new observation
				</Button>

				<Button type="button" onClick={redirectAndResetForm} className="w-full">
					{window.ReactNativeWebView ? "Close" : "Select another form"}
				</Button>
			</div>
		</div>
	);
};

export default QuitForm;
